<template>
  <b-modal id="akt-options-popup-modal"
           hide-footer
           :title="$t('options')"
           size="sm"
           @close="emit('changed', selected)"
           centered>
    <SelectGroup :options="signers"
                 v-model="signer"
                 variant="white"
                 :required="true"
                 :null-option="false"
                 :showlabel="true"
                 :label="$t('choose_signer')"/>
    <DateGroup v-model="date"
               v-if="dateSelectionEnabled"
               :showlabel="true"
               :label="$t('date')"
               :required="true"/>
    <div class="mt-5">
    <button class="btn-themed btn-themed-squared w-100"
            @click="print">
      {{ $t('print') }}
    </button>
    </div>
  </b-modal>
</template>

<script setup>
import {getCurrentInstance, onMounted, ref, watch} from "vue"
import SelectGroup from "@/components/form/SelectGroup.vue"
import DateGroup from "@/components/form/DateGroup.vue"
import moment from "moment/moment"

const { defaultDate } = defineProps({
  title: {
    type: String,
    default: ''
  },
  defaultDate: {
    type: String,
    default: ''
  },
  dateSelectionEnabled: {
    type: Boolean,
    default: true
  }
})

const signer = ref('admin')
const date = ref('')

const signers = [
  { id: 'admin', title: 'manager' },
  { id: 'doctor', title: 'doctor' },
  { id: 'director', title: 'director' }
]

const emit = defineEmits(['changed'])
const selected = ref(null)

let bvModal = null

onMounted(() => {
  const instance = (getCurrentInstance())
  bvModal = instance?.ctx?._bv__modal
  date.value = defaultDate || moment().format('YYYY-MM-DD')
  if(localStorage && localStorage.getItem('akt-signer')) {
    signer.value = localStorage.getItem('akt-signer')
  }
})

const print = async () => {
  bvModal.hide('akt-options-popup-modal')
  emit('changed', {
    signer: signer.value,
    date: date.value
  })
}

watch(signer, (val) => {
  if(localStorage) {
    localStorage.setItem('akt-signer', val)
  }
})
</script>
